/**
 * Where a visitor belongs, from their auth state alone (doc 88 D10).
 *
 * One rule for every route that cares — `RequireAuth`, `HomeRoute`, the sign-in
 * and verify screens — because `HomeRoute` and `SignInPage` sit OUTSIDE
 * `RequireAuth`. Before this, `/` opened live Firestore listeners for anyone
 * signed in; an account whose email is not yet confirmed is signed in but
 * refused by every rule, so it would have met a wall of permission errors.
 * Nothing that reads data may mount before `'ready'`.
 */
export type AuthGate = 'loading' | 'signed_out' | 'unverified' | 'ready';

export function authGate(state: { loading: boolean; user: { emailVerified: boolean } | null }): AuthGate {
  if (state.loading) return 'loading';
  if (!state.user) return 'signed_out';
  return state.user.emailVerified ? 'ready' : 'unverified';
}

/** The one screen each settled state lives on. */
export const GATE_PATH: Record<Exclude<AuthGate, 'loading'>, string> = {
  signed_out: '/signin',
  unverified: '/verify-email',
  ready: '/',
};
